module.exports = __webpack_public_path__ + "img/aut_eknscnzpk6s_unsp_STCZo.209b56be.jpg";